import * as types from 'store/modules/hres82e/mutation-types'
import hres82e from 'api/hres82e'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import hres82eLabels from 'assets/labels/hres82e'
import { hres82eColumns } from 'assets/columns/hres82e'
import configLabel from 'src/../config/label'
import moment from 'moment'

export default {
  state: {
    indexDisp: true,
    roomDetailDisp: false,
    detailDisp: false,
    calendarDetailDisp: false,
    reserveDisp: false,
    labels: hres82eLabels,
    columns: hres82eColumns(),
    index: {
      total: 0,
      rows: []
    },
    calendar: {
      total: 0,
      rows: []
    },
    roomDetail: {},
    calendarDetail: {
      total: 0,
      rows: []
    },
    reserveDetail: {
      dtereq: '',
      seqno: '',
      timstrt: '',
      timend: '',
      staappr: 'B',
      desc_staappr: '',
      object: '',
      remark: '',
      qtypers: '',
      codempid: '',
      desc_codempid: '',
      codappr: '',
      desc_codappr: ''
    },
    indexSelected: [],
    calendarSelected: [],
    dateSelected: ''
  },
  getters: {
    [types.GET_HRES82E_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES82E_ROOM_DETAIL_DISP] (state) {
      return state.roomDetailDisp
    },
    [types.GET_HRES82E_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES82E_CALENDAR_DETAIL_DISP] (state) {
      return state.calendarDetailDisp
    },
    [types.GET_HRES82E_RESERVE_DISP] (state) {
      return state.reserveDisp
    },
    [types.GET_HRES82E_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES82E_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES82E_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES82E_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES82E_CALENDAR_SELECTED] (state) {
      return state.calendarSelected
    },
    [types.GET_HRES82E_ROOM_DETAIL] (state) {
      return state.roomDetail
    },
    [types.GET_HRES82E_CALENDAR] (state) {
      return state.calendar
    },
    [types.GET_HRES82E_CALENDAR_DETAIL] (state) {
      return state.calendarDetail
    },
    [types.GET_HRES82E_RESERVE_DETAIL] (state) {
      return state.reserveDetail
    },
    [types.GET_HRES82E_DATE_SELECTED] (state) {
      return state.dateSelected
    }
  },
  mutations: {
    [types.SET_HRES82E_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES82E_ROOM_DETAIL_DISP] (state, roomDetailDisp) {
      state.roomDetailDisp = roomDetailDisp
    },
    [types.SET_HRES82E_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES82E_CALENDAR_DETAIL_DISP] (state, calendarDetailDisp) {
      state.calendarDetailDisp = calendarDetailDisp
    },
    [types.SET_HRES82E_RESERVE_DISP] (state, reserveDisp) {
      state.reserveDisp = reserveDisp
    },
    [types.SET_HRES82E_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detail = configLabel.replaceLabelToColumns(state.columns[keyLang].detail, labels[keyLang])
      }
    },
    [types.SET_HRES82E_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES82E_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES82E_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES82E_CALENDAR_SELECTED] (state, calendarSelected) {
      state.calendarSelected = calendarSelected
    },
    [types.SET_HRES82E_ROOM_DETAIL] (state, data) {
      state.roomDetail = data
    },
    [types.SET_HRES82E_CALENDAR] (state, data) {
      state.calendar = data
    },
    [types.SET_HRES82E_CALENDAR_DETAIL] (state, data) {
      state.calendarDetail = data
    },
    [types.SET_HRES82E_RESERVE_DETAIL] (state, data) {
      state.reserveDetail = data
    },
    [types.SET_HRES82E_DATE_SELECTED] (state, dateSelected) {
      state.dateSelected = dateSelected
    }
  },
  actions: {
    [types.TOGGLE_HRES82E_PAGE] ({ commit }, page) {
      let indexDisp = false
      let roomDetailDisp = false
      let detailDisp = false
      let calendarDetailDisp = false
      let reserveDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'roomDetail':
          roomDetailDisp = true
          break
        case 'detail':
          detailDisp = true
          calendarDetailDisp = true
          break
        case 'reserve':
          detailDisp = true
          reserveDisp = true
          break
      }
      commit(types.SET_HRES82E_INDEX_DISP, indexDisp)
      commit(types.SET_HRES82E_ROOM_DETAIL_DISP, roomDetailDisp)
      commit(types.SET_HRES82E_DETAIL_DISP, detailDisp)
      commit(types.SET_HRES82E_CALENDAR_DETAIL_DISP, calendarDetailDisp)
      commit(types.SET_HRES82E_RESERVE_DISP, reserveDisp)
    },
    [types.RECEIVED_HRES82E_COLUMNS_LABELS] ({ commit }) {
      hres82e.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES82E_COLUMNS, data.labels)
          commit(types.SET_HRES82E_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES82E_INDEX] ({ commit }, searchParams) {
      hres82e.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          for (var i = 0; i < data.rows.length; i++) {
            data.rows[i].staappr = ''
          }
          commit(types.SET_HRES82E_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES82E_ROOM_DETAIL] ({ commit }, searchParams) {
      hres82e.getRoomDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES82E_ROOM_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES82E_CALENDAR] ({ commit }, searchParams) {
      hres82e.getCalendar(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES82E_CALENDAR, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES82E_CALENDAR_DETAIL] ({ commit }, searchParams) {
      hres82e.getCalendarDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES82E_CALENDAR_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES82E_RESERVE_CREATE] ({ commit }, searchParams) {
      let data = {
        dtereq: moment().format('DD/MM/YYYY'),
        seqno: '',
        timstrt: '',
        timend: '',
        staappr: 'B',
        desc_staappr: '',
        object: '',
        remark: '',
        qtypers: '',
        codempid: '',
        desc_codempid: '',
        codappr: '',
        desc_codappr: ''
      }
      commit(types.SET_HRES82E_RESERVE_DETAIL, data)
    },
    [types.RECEIVED_HRES82E_RESERVE_DETAIL] ({ commit }, searchParams) {
      hres82e.getReserveDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES82E_RESERVE_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES82E_RESERVE_CANCEL] ({ commit, dispatch }, { cancelParams, searchParams }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmCancel'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres82e.postReserveCancel(cancelParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRES82E_INDEX, searchParams)
              dispatch(types.RECEIVED_HRES82E_CALENDAR, cancelParams)
              dispatch(types.RECEIVED_HRES82E_CALENDAR_DETAIL, cancelParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRES82E_RESERVE_SAVE] ({ commit, dispatch }, { saveParams, searchParams }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres82e.postReserveSave(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRES82E_INDEX, searchParams)
              dispatch(types.RECEIVED_HRES82E_CALENDAR, saveParams)
              dispatch(types.RECEIVED_HRES82E_CALENDAR_DETAIL, saveParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
              dispatch(types.TOGGLE_HRES82E_PAGE, 'detail')
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres82e/index.js